<template>
  <div class="row no-gutters" :style="`
    font-size: ${size}px;
    max-width: fit-content;
    min-width: fit-content;
    flex-wrap: nowrap;`
">
  <template v-for="(text, index) in keys">
    <div class="elevation-2 px-2 py-1 key" :key="text+index">{{text}}</div>  
    <div v-if="index < keys.length - 1" class="px-1 py-1 plus" :key="'key'+index">+</div>
  </template>
</div>
</template>

<script>
export default {
  props: {
    size: {
      default: '14'
    },
    keys: {
    }
  }
}
</script>

<style scoped>
.key {
  border-radius: 6px;
  font-size: 1em;
}

.plus {
  font-size: 1em;
}
</style>>

</style>